import { render } from "./UserCorporateLayout.vue?vue&type=template&id=0445a96b&scoped=true&ts=true&lang=pug"
import script from "./UserCorporateLayout.vue?vue&type=script&lang=ts"
export * from "./UserCorporateLayout.vue?vue&type=script&lang=ts"

import "./UserCorporateLayout.vue?vue&type=style&index=0&id=0445a96b&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0445a96b"]])

export default __exports__